<!--
    Display an icon and a modal to change connect account with sso
 -->
<script setup lang="ts">
/* UTILS */
/* COMPONENTS */
import { AfModal, localStorageHelpers } from '@af-lib/ui-lib';
import { ref } from 'vue';

import { clearCookieSpaces } from '@/config/spaces';
/* STORES */
import { useGlobalStore } from '@/stores/global';
import { ALIconButton } from '@af-lib/vue-ui';

const globalStore = useGlobalStore();
const showDevModal = ref(false);
/**
 * Users a referenced in the config.json file
 */
const availableDevUsers = globalStore.getDevUsers;
/**
 * Current connected account
 */
const devAccount = localStorageHelpers.getLocalItem('dev_account');

/* FUNCTION */
/**
 * Will store the email for the connection, and reload.
 * If the selected user is the same as the one connected, delete it
 *
 * @param {string} devUserEmail - email to connect with
 */
function setDevAccount(devUserEmail) {
  clearCookieSpaces();
  if (devUserEmail === devAccount) {
    localStorageHelpers.setLocalItem('dev_account', null);
  } else {
    localStorageHelpers.setLocalItem('dev_account', devUserEmail);
  }

  window.location.reload();
}
</script>

<template>
  <ALIconButton
    v-if="globalStore.getEnvironment === 'dev' && availableDevUsers.length"
    variant="tertiary"
    icon="fa-code"
    label="See users"
    :shouldTeleportTooltip="true"
    @click="showDevModal = !showDevModal"
  />
  <AfModal
    v-if="globalStore.getEnvironment === 'dev' && availableDevUsers.length"
    v-model="showDevModal"
    title="Dev Zone"
  >
    <template #content>
      <v-card
        v-for="user in availableDevUsers"
        :key="user.email"
        :selected="user.email === devAccount"
        class="d-flex flex-row align-center mb-2 usercard"
        link
        @click="setDevAccount(user.email)"
      >
        <v-card-item>
          <div>
            <v-card-title>{{ user.email }}</v-card-title>
            <v-card-subtitle>{{ user.desc }}</v-card-subtitle>
          </div>
        </v-card-item>
      </v-card>
    </template>
  </AfModal>
</template>

<style scoped lang="scss">
.usercard[selected='true'] {
  border-color: var(--color-af-primary);
}
</style>
